// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import './js/extentions-tool'
import $ from 'jquery'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'
import './css/app.css'
import './css/iconfont/iconfont.css'
import 'video.js'
import moment from "moment";

import SlideVerify from 'vue-monoplasty-slide-verify'
import VueWechatTitle from 'vue-wechat-title'
import Vuex from 'vuex'
// import VueWorker from 'vue-worker'
import Toast from "./components/toast";
import HTTP from './js/api-defines';

import StoreManager from './js/data-store';
// import VAutocomplete from 'v-autocomplete'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// import VueQuillEditor from "vue-quill-editor";

// import "quill/dist/quill.core.css";
// import "quill/dist/quill.snow.css";
// import "quill/dist/quill.bubble.css";
import 'jq-signature';
import "./js/import-remote-js.js";


Vue.use(SlideVerify);
Vue.use(VueWechatTitle);
Vue.use(Vuex);
// Vue.use(VueWorker);
Vue.use(Toast);
// Vue.use(VAutocomplete);
Vue.use(ElementUI);
// Vue.use(VueQuillEditor);


Vue.prototype.$moment = moment;

Vue.config.productionTip = false;

/* eslint-disable no-new */

import DefaultConfig from './js/shba'
import EventManager from './js/event-common';


const store = new Vuex.Store({
  state: {
    tabList: DefaultConfig.tabList,
    currentTabId: DefaultConfig.tabList[0].id,
    whiteList: DefaultConfig.whiteList,
    testNumber: 0,
    http: HTTP,
    dataStore: StoreManager,
    user: null,
    memberTeams: null,
    introduceData: null,
    banners: null,
    showWechatDialog: false,
    wechatModel: null,
    eventManager: EventManager,
    judgeList: null,
    coachData: null,
    allowedLeave: true,
    updateJudgeList: false,
    idErrorRemark: null,
    judgeApplyDuration: null,
    typeNameAllowedList: [
      '个人用户',
      '团体用户',
      '个人会员',
      '团体会员'
    ],
  },

  mutations: {
    tabIndexChanged(state, tabId) {
      state.currentTabId = tabId;
    },
    addTestNumber(state, addNum) {
      state.testNumber += addNum;
    },
    setUser(state, user) {
      state.user = user;
    },
    setMemberTeams(state, memberList) {
      state.memberTeams = memberList;
    },
    setIntroduce(state, introduceData) {
      state.introduceData = introduceData;
    },
    setBanners(state, banners) {
      state.banners = banners;
    },
    setShowWechatDialog(state, show) {
      state.showWechatDialog = show;
    },
    setWechatModel(state, model) {
      state.wechatModel = model;
    },
    setJudgeList(state, list) {
      state.judgeList = list;
    },
    setCoachData(state, coachData) {
      state.coachData = coachData;
    },
    isAllowedLeave(state, allowed) {
      state.allowedLeave = allowed;
    },
    needUpdateJudgeList(state, updated) {
      state.updateJudgeList = updated;
    },
    setIdErrorRemark(state, errorRemark) {
      state.idErrorRemark = errorRemark;
    },
    setJudgeApplyDuration(state, judgeApplyDuration) {
      state.judgeApplyDuration = judgeApplyDuration;
    },
  },
})


// window.Vue = Vue;

var vue = new Vue({
  el: '#app',
  router,
  store,
  myTool: DefaultConfig,
  components: { App },
  template: '<App/>'
});

export default vue;

router.beforeEach((to, from, next) => {
  // console.log('beforeEach');
  let allowedLeave = store.state.allowedLeave;
  if (allowedLeave) {
    let updateJudgeList = store.state.updateJudgeList;
    if (updateJudgeList) {
      EventManager.postNotification(EventManager.notificationNameObject.judgeApplicationSuccess, null);
      store.commit("updateJudgeList", false);
    }
  }
  next(allowedLeave);
  if (!allowedLeave) {
    EventManager.postNotification(EventManager.notificationNameObject.updatePersonalCenterTabs, null);
    vue.$confirm('退出当前页面，作出的修改将不会保存，确定退出吗', '提示', {
      confirmButtonText: '退出',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      store.commit('isAllowedLeave', true);
      router.push(to);
    });
  }
});



// WEBPACK FOOTER //
// ./src/main.js